// @material-ui/icons
import Fingerprint from "@material-ui/icons/Fingerprint";

import LoginPage from "../views/Pages/LoginPage";
import ForgetPage from "../components/Custom/ForgetPassword";
import ChangePassword from "../components/Custom/ChangePassword";
import DashBoard from "../views/BerPay/dashboard";

const pagesRoutes = [
  {
    path: "/admin/pages/login-page",
    name: "Login Page",
    short: "Login",
    mini: "LP",
    icon: Fingerprint,
    component: LoginPage,
  },
  {
    path: "/admin/pages/forgetpassword",
    name: "Forget Password",
    short: "Forget",
    mini: "LP",
    icon: Fingerprint,
    component: ForgetPage,
  },
  {
    path: "/admin/pages/resetPassword",
    short: "Forget",
    mini: "LP",
    icon: Fingerprint,
    component: ChangePassword,
  },
  {
    path: "/admin/pages/dashboard",
    name: "Forget Password",
    short: "Forget",
    mini: "LP",
    icon: Fingerprint,
    component: DashBoard,
  },
  {
    redirect: true,
    path: "/admin/pages",
    pathTo: "/admin/pages/login-page",
    name: "Login Page",
  },
];

export default pagesRoutes;
